$(document).ready(function () {

  $('.js-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    items: 1,
    mouseDrag:false,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 1000,
    animateIn:'fadeInRight',
    animateOut: 'fadeOutLeft',
    navText: ["<span class='prev iconFont iconFont--smallx'></span>","<span class='next iconFont iconFont--smallx'></span>"]
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 900) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  $(".button--animate").lettering();

  AOS.init();

  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });

});

$(window).scroll(function(){
  if($(window).scrollTop() > 65 ) {
    $(".header").addClass('header--scroll');
  } else {
    $(".header").removeClass('header--scroll');
  }
});

$(document).on('click','.js-videoPoster',function(e) {
  e.preventDefault();
  var poster = $(this);
  var wrapper = poster.closest('.js-videoWrapper');
  videoPlay(wrapper);
});

function videoPlay(wrapper) {
  var iframe = wrapper.find('.js-videoIframe');
  var src = iframe.data('src');
  wrapper.addClass('videoWrapperActive');
  iframe.attr('src',src);
}
